const Category = [
  "Normal morphology",
  "Abnormal morphology",
  "a. Head defects",
  "b. Neck & mid piece",
  "c. Tail defects",
];

export default Category;
